export function formatPrice(price: number) {
    if (Number.isInteger(price)) {
        return `$${price}`;
    }

    return `$${price.toFixed(2)}`;
}
